<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"
                                         :$_em-custom-vuex-mixin_entity="entityState"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // Author THQ
    // Date 2025-04-08 17:07:36

    import emCommonEditMixin from "@/mixin/em/common/edit";

    export default {
        name: "ppeApplyScrapDetailEditView",
        mixins: [emCommonEditMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            entityState() {
                return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
            }
        }
    };
</script>